import { render, staticRenderFns } from "./withdrawList.vue?vue&type=template&id=bf4fa7e8&scoped=true"
import script from "./withdrawList.vue?vue&type=script&lang=js"
export * from "./withdrawList.vue?vue&type=script&lang=js"
import style0 from "./withdrawList.vue?vue&type=style&index=0&id=bf4fa7e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4fa7e8",
  null
  
)

export default component.exports